<template>
  <div class="flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto">
    <div class="w-full h-12 p-4 shadow-md ">
      <span class="text-large text-black text-bold font-600 mr-3">Layout4</span>
    </div>

    <div class="flex flex-col px-4 gap-4 mt-4 w-full items-center">
      <div class="w-full flex justify-start border border-gray-300 rounded-md p-4">

        <el-form :model="form" label-width="auto" class="w-full">

          <div class="flex w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">

            <el-form-item label="Activity name">
              <el-input v-model="form.name" />
            </el-form-item>

            <el-form-item label="Activity zone">
              <el-select v-model="form.region" placeholder="please select your zone">
                <el-option label="Zone one" value="shanghai" />
                <el-option label="Zone two" value="beijing" />
              </el-select>
            </el-form-item>

            <el-form-item label="Activity time">
              <el-col :span="11">
                <el-date-picker v-model="form.date1" type="date" placeholder="Pick a date" style="width: 100%" />
              </el-col>
              <el-col :span="2" class="text-center">
                <span class="text-gray-500">-</span>
              </el-col>
              <el-col :span="11">
                <el-time-picker v-model="form.date2" placeholder="Pick a time" style="width: 100%" />
              </el-col>
            </el-form-item>
            <div class="flex col-span-1 md:col-span-2 lg:col-span-3 justify-end">

              <el-button class="w-24" type="primary" @click="handleSubmit">新規登録</el-button>
              <el-button class="w-24" type="primary" @click="handleSubmit">検索</el-button>
            </div>
          </div>
        </el-form>

      </div>


      <div class="w-full flex justify-start border border-gray-300 rounded-md p-4">
        <el-table :data="tableData" :table-layout="tableLayout" :loading="loading">
          <el-table-column prop="date" label="Date" />
          <el-table-column prop="name" label="Name" />
          <el-table-column class="hidden" prop="address" label="Address" />
        </el-table>
      </div>

      <div class="w-full flex justify-end">
        <el-radio-group v-model="tableLayout">
          <el-radio-button value="fixed">fixed</el-radio-button>
          <el-radio-button value="auto">auto</el-radio-button>
        </el-radio-group>
        <el-pagination class="ml-4" v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper" :total="400" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { ElPagination, ElTable, ElTableColumn, type TableInstance } from 'element-plus'

export default defineComponent({
  name: 'Layout4',
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
  },
  setup() {
    // https://element-plus.org/zh-CN/component/loading.html
    const loading = ref(true);
    const form = ref({
      name: '',
      region: '',
      date1: '',
      date2: '',
    });
    const tableLayout = ref<TableInstance['tableLayout']>('fixed');
    const currentPage = ref(1);
    const pageSize = ref(10);
    const size = ref('small');
    const disabled = ref(false);
    const background = ref(true);

    const tableData = [
      {
        date: '2016-05-02',
        name: 'John Smith',
        address: 'No.1518,  Jinshajiang Road, Putuo District',
      },
      {
        date: '2016-05-04',
        name: 'John Smith',
        address: 'No.1518,  Jinshajiang Road, Putuo District',
      },
      {
        date: '2016-05-01',
        name: 'John Smith',
        address: 'No.1518,  Jinshajiang Road, Putuo District',
      },
    ];

    onMounted(() => {
      loading.value = true
      setTimeout(() => {
        loading.value = false
      }, 2000);
    })

    const handleSizeChange = (val: number) => {
      console.log(val)
    }

    const handleCurrentChange = (val: number) => {
      console.log(val)
    }

    const handleSubmit = () => {
      console.log(form.value)
    }

    return {
      loading,
      tableLayout,
      tableData,
      currentPage,
      form,
      pageSize,
      size,
      handleSubmit,
      handleSizeChange,
      handleCurrentChange,
    }
  }
});
</script>